<div
  class="pre-modal__backdrop"
  [class.pre-modal__backdrop--visible]="isOpen()"
  aria-hidden="true"
  (click)="onBackdropClick($event)"
></div>

@if (product(); as p) {
  <section
    #modalEl
    class="pre-modal"
    [class.pre-modal--open]="isOpen()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pre-modal-title"
    tabindex="-1"
  >
    <header class="pre-modal__header">
      <div class="pre-modal__header-info">
        <!-- Slot PROPIO del badge VIP (R3): una precompra restringida muestra
             los dos badges; antes el VIP desplazaba a «Pre-venta». -->
        @if (isEarlyAccessProduct()) {
          <app-badge variant="vip">{{ eaBadgeText() }}</app-badge>
        }
        <app-badge variant="pre-sale">Pre-venta</app-badge>
        <h2 id="pre-modal-title" class="pre-modal__title">Reservar producto</h2>
      </div>
      <button
        #closeBtn
        class="pre-modal__close"
        type="button"
        aria-label="Cerrar"
        (click)="onClose()"
      >
        <app-icon [icon]="closeIcon" [size]="20" color="currentColor" />
      </button>
    </header>

    <div #bodyEl class="pre-modal__body">
      @if (status() === 'success') {
        <div class="pre-modal__success">
          <app-icon [icon]="successIcon" [size]="48" color="var(--color-success, #059669)" />
          <p class="pre-modal__success-text">{{ successMessage() }}</p>
          <p class="pre-modal__success-method">
            {{ copy.success.deliveryLabel }} <strong>{{ deliveryMethodLabel() }}</strong>
          </p>
          <p class="pre-modal__success-subtext">
            {{ copy.success.dueDateLabel }}
            <strong>{{ dueDateLabel() || copy.success.dueDateFallback }}</strong>
          </p>
          @if (isAuthenticated()) {
            <p class="pre-modal__pp-note pre-modal__pp-note--success">
              <app-pp-coin [size]="16" />
              <span>{{ copy.perronPoints.manual }}</span>
            </p>
          }
          <div class="pre-modal__success-actions">
            <app-button variant="secondary" (click)="onClose()">
              {{ copy.success.ctaClose }}
            </app-button>
            <app-button variant="primary" (click)="onViewOtherPrepurchases()">
              {{ copy.success.ctaBrowse }}
            </app-button>
          </div>
        </div>
      } @else if (step() === 'payment') {
        <!-- Paso de MÉTODO DE PAGO del abono (30%). El submit del formulario ya
             validó, guardó el payload y ABRIÓ LA RESERVA flotante de 15 min
             (Bloque 2, D5: el countdown arranca aquí). Elegir un método abre el
             modal de comprobante reutilizado del checkout (create-on-finalize).
             Solo sinpe/transfer en el Bloque 1: la tarjeta llega con ONVO (B3). -->
        <div class="pre-modal__payment-step">
          <article class="pre-modal__product">
            <img
              class="pre-modal__product-img"
              [src]="thumbnailUrl()"
              [alt]="p.name"
              loading="lazy"
              (error)="onImageError($event)"
            />
            <div class="pre-modal__product-info">
              <p class="pre-modal__product-name">{{ p.name }}</p>
              <p class="pre-modal__product-price">
                {{ formatCRC(unitPrice()) }} <span>por unidad</span>
              </p>
            </div>
          </article>

          @if (reservationNotice(); as notice) {
            <!-- La reserva expiró (countdown a 0), el cupo se agotó al reintentar
                 (sold_out, 409) o el rate-limiter cortó la apertura (throttled,
                 429): aviso verbatim + CTA que abre una sesión NUEVA. Lo tecleado
                 en el formulario no se pierde. -->
            <div class="pre-modal__alert pre-modal__alert--error" role="alert">
              <strong>
                @switch (notice) {
                  @case ('sold_out') {
                    {{ copy.reservation.soldOut }}
                  }
                  @case ('throttled') {
                    {{ copy.reservation.throttled }}
                  }
                  @default {
                    {{ copy.reservation.expired }}
                  }
                }
              </strong>
            </div>

            <footer class="pre-modal__footer">
              <app-button variant="secondary" (click)="onBackToForm()">
                {{ copy.paymentStep.back }}
              </app-button>
              <app-button
                variant="primary"
                [loading]="sessionOpening()"
                (click)="onRetryReservation()"
              >
                {{ copy.reservation.retryCta }}
              </app-button>
            </footer>
          } @else {
            @if (showCountdown()) {
              <!-- Countdown de la reserva (copy verbatim con {mm:ss}); la
                   expiración la gestiona ESTE countdown, único con handler. -->
              <p class="pre-modal__timer">
                <app-countdown
                  [expiresAt]="sessionExpiresAt()"
                  [label]="copy.reservation.timer"
                  (expired)="onReservationExpired()"
                />
              </p>
            }

            <div class="pre-modal__totals">
              <div class="pre-modal__totals-row pre-modal__totals-row--accent">
                <span>Abono inicial (30%)</span>
                <strong>{{ formatCRC(effectiveDeposit()) }}</strong>
              </div>
              <p class="pre-modal__totals-note">{{ copy.totalsNote }}</p>
              @if (isAuthenticated()) {
                <p class="pre-modal__pp-note">
                  <app-pp-coin [size]="16" />
                  <span>{{ copy.perronPoints.both }}</span>
                </p>
              }
            </div>

            <h3 class="pre-modal__payment-title">{{ paymentStepTitle }}</h3>
            <div
              class="pre-modal__delivery-options"
              role="group"
              [attr.aria-label]="paymentStepTitle"
              [attr.aria-busy]="sessionOpening()"
            >
              @for (option of paymentOptions; track option.key) {
                <button
                  type="button"
                  class="pre-modal__delivery-option pre-modal__payment-option"
                  [disabled]="sessionOpening()"
                  (click)="onSelectPaymentMethod(option.key)"
                >
                  <span class="pre-modal__delivery-option-body">
                    <span
                      class="pre-modal__delivery-option-title"
                      [innerHTML]="option.title"
                    ></span>
                    <span class="pre-modal__delivery-option-meta">{{ option.meta }}</span>
                  </span>
                </button>
              }
            </div>

            <footer class="pre-modal__footer">
              <app-button variant="secondary" (click)="onBackToForm()">
                {{ copy.paymentStep.back }}
              </app-button>
            </footer>
          }
        </div>
      } @else {
        <article class="pre-modal__product">
          <img
            class="pre-modal__product-img"
            [src]="thumbnailUrl()"
            [alt]="p.name"
            loading="lazy"
            (error)="onImageError($event)"
          />
          <div class="pre-modal__product-info">
            <p class="pre-modal__product-name">{{ p.name }}</p>
            <p class="pre-modal__product-price">
              {{ formatCRC(unitPrice()) }} <span>por unidad</span>
            </p>
            @if (dueDateShort()) {
              <p class="pre-modal__product-hint">
                <app-icon [icon]="calendarIcon" [size]="14" color="currentColor" />
                Entrega aprox. {{ dueDateShort() }}
              </p>
            }
            @if (perClientLimit()) {
              <p class="pre-modal__product-hint">
                <app-icon [icon]="infoIcon" [size]="14" color="currentColor" />
                Máximo {{ perClientLimit() }}
                {{ perClientLimit() === 1 ? 'unidad' : 'unidades' }} por persona
              </p>
            }
          </div>
        </article>

        @if (isDeadlinePassed()) {
          <div class="pre-modal__alert pre-modal__alert--error" role="alert">
            La ventana de reservas cerró el {{ dueDateShort() }}. Este producto ya no está
            disponible para precompra.
          </div>
        }

        @if (eaVariant() === 'login') {
          <div class="pre-modal__alert pre-modal__alert--error" role="alert">
            <span><app-pp-coin [size]="16" />{{ withThreshold(eaCopy.guestLocked, eaThreshold()) }}</span>
            <button type="button" class="pre-modal__login-link" (click)="onOpenLogin()">
              {{ eaCopy.guestLockedCta }}
            </button>
          </div>
        } @else if (eaVariant() === 'loading') {
          <div class="pre-modal__alert" role="status">
            <span>{{ eaCopy.loadingLocked }}</span>
          </div>
        } @else if (eaVariant() === 'error') {
          <div class="pre-modal__alert pre-modal__alert--error" role="alert">
            <span>{{ eaCopy.unavailableLocked }}</span>
            <button type="button" class="pre-modal__login-link" (click)="onRetryPoints()">
              {{ eaCopy.retryCta }}
            </button>
          </div>
        } @else if (eaVariant() === 'insufficient') {
          <div class="pre-modal__alert pre-modal__alert--error" role="alert">
            <span><app-pp-coin [size]="16" />{{ withEarlyAccessInsufficient(eaCopy.insufficientLocked, eaThreshold(), pointsService.balance()) }}</span>
          </div>
        } @else if (eaVariant() === 'granted') {
          <div class="pre-modal__alert pre-modal__alert--success" role="status">
            <span><app-pp-coin face="corgi" [size]="20" />{{ eaCopy.grantedMessage }}</span>
          </div>
        }

        @if (errorPanel(); as err) {
          <div class="pre-modal__alert pre-modal__alert--error" role="alert">
            <strong>{{ errorHeading() }}</strong>
            @if (err.message && err.message !== errorHeading()) {
              <span class="pre-modal__alert-detail">{{ err.message }}</span>
            }
            @if (err.reason === 'ea_login_required') {
              <button type="button" class="pre-modal__login-link" (click)="onOpenLogin()">
                {{ eaCopy.guestLockedCta }}
              </button>
            }
          </div>
        }

        <form class="pre-modal__form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
          <div class="pre-modal__qty-row">
            <span class="pre-modal__qty-label">Cantidad a reservar</span>
            <div class="pre-modal__qty">
              <button
                type="button"
                class="pre-modal__qty-btn"
                [disabled]="form.controls.quantity.value <= 1 || isDeadlinePassed()"
                aria-label="Disminuir cantidad"
                (click)="decrement()"
              >
                <app-icon [icon]="minusIcon" [size]="14" color="currentColor" />
              </button>
              <span class="pre-modal__qty-value" aria-live="polite">
                {{ form.controls.quantity.value }}
              </span>
              <button
                type="button"
                class="pre-modal__qty-btn"
                [disabled]="form.controls.quantity.value >= maxQuantity() || isDeadlinePassed()"
                aria-label="Aumentar cantidad"
                (click)="increment()"
              >
                <app-icon [icon]="plusIcon" [size]="14" color="currentColor" />
              </button>
            </div>
          </div>

          <div class="pre-modal__totals">
            <div class="pre-modal__totals-row">
              <span>Subtotal</span>
              <strong>{{ formatCRC(subtotal()) }}</strong>
            </div>
            <div class="pre-modal__totals-row">
              <span>Envío</span>
              <strong>
                @switch (deliveryMethod()) {
                  @case ('ps') {
                    Retiro en tienda
                  }
                  @case ('uber') {
                    Por tu cuenta
                  }
                  @case ('ps_delivery') {
                    {{ formatCRC(deliveryPrice()) }}
                  }
                  @case ('home') {
                    @if (deliveryPrice() > 0) {
                      {{ formatCRC(deliveryPrice()) }}
                    } @else {
                      Gratis
                    }
                  }
                }
              </strong>
            </div>
            <div class="pre-modal__totals-row pre-modal__totals-row--accent">
              <span>Abono inicial (30%)</span>
              <strong>{{ formatCRC(depositAmount()) }}</strong>
            </div>
            <p class="pre-modal__totals-note">{{ copy.totalsNote }}</p>
            @if (isAuthenticated()) {
              <p class="pre-modal__pp-note">
                <app-pp-coin [size]="16" />
                <span>{{ copy.perronPoints.both }}</span>
              </p>
            }
          </div>

          @if (!isAuthenticated()) {
            <p class="pre-modal__login-banner">
              ¿Ya tienes cuenta?
              <button type="button" class="pre-modal__login-link" (click)="onOpenLogin()">
                Inicia sesión
              </button>
              <span class="pre-modal__login-hint">y autocompletaremos tus datos.</span>
            </p>
          } @else {
            <p class="pre-modal__login-banner pre-modal__login-banner--logged">
              Sesión iniciada como <strong>{{ currentUser()?.email }}</strong>
            </p>
          }

          <fieldset class="pre-modal__fieldset">
            <legend class="pre-modal__legend">Tus datos</legend>

            <div class="pre-modal__grid">
              <label class="pre-modal__field">
                <span class="pre-modal__field-label">Nombre *</span>
                <input
                  type="text"
                  formControlName="name"
                  autocomplete="given-name"
                  class="pre-modal__input"
                  [class.pre-modal__input--error]="hasError('name')"
                />
                @if (hasError('name')) {
                  <span class="pre-modal__field-error" role="alert">{{ errorFor('name') }}</span>
                }
              </label>

              <label class="pre-modal__field">
                <span class="pre-modal__field-label">Apellidos *</span>
                <input
                  type="text"
                  formControlName="surnames"
                  autocomplete="family-name"
                  class="pre-modal__input"
                  [class.pre-modal__input--error]="hasError('surnames')"
                />
                @if (hasError('surnames')) {
                  <span class="pre-modal__field-error" role="alert">{{
                    errorFor('surnames')
                  }}</span>
                }
              </label>

              <label class="pre-modal__field">
                <span class="pre-modal__field-label">Cédula</span>
                <input
                  type="text"
                  formControlName="identification"
                  class="pre-modal__input"
                  [class.pre-modal__input--error]="hasError('identification')"
                />
                @if (hasError('identification')) {
                  <span class="pre-modal__field-error" role="alert">{{
                    errorFor('identification')
                  }}</span>
                }
              </label>

              <label class="pre-modal__field">
                <span class="pre-modal__field-label">Correo *</span>
                <input
                  type="email"
                  formControlName="email"
                  autocomplete="email"
                  class="pre-modal__input"
                  [class.pre-modal__input--error]="hasError('email')"
                />
                @if (hasError('email')) {
                  <span class="pre-modal__field-error" role="alert">{{ errorFor('email') }}</span>
                }
              </label>

              <label class="pre-modal__field">
                <span class="pre-modal__field-label">Teléfono *</span>
                <input
                  type="tel"
                  formControlName="phone"
                  autocomplete="tel"
                  class="pre-modal__input"
                  [class.pre-modal__input--error]="hasError('phone')"
                />
                @if (hasError('phone')) {
                  <span class="pre-modal__field-error" role="alert">{{ errorFor('phone') }}</span>
                }
              </label>
            </div>
          </fieldset>

          <fieldset class="pre-modal__fieldset">
            <legend class="pre-modal__legend">Método de envío *</legend>
            <div class="pre-modal__delivery-options" role="radiogroup" aria-label="Método de envío">
              <label class="pre-modal__delivery-option">
                <input
                  type="radio"
                  name="delivery_method"
                  value="ps"
                  formControlName="delivery_method"
                />
                <span class="pre-modal__delivery-option-body">
                  <span class="pre-modal__delivery-option-title">
                    Retirar en <strong>Perrón Store</strong>
                  </span>
                  <span class="pre-modal__delivery-option-meta">Gratis</span>
                </span>
              </label>

              <label class="pre-modal__delivery-option">
                <input
                  type="radio"
                  name="delivery_method"
                  value="uber"
                  formControlName="delivery_method"
                />
                <span class="pre-modal__delivery-option-body">
                  <span class="pre-modal__delivery-option-title">
                    Enviaré un mensajero <strong>(Uber Flash, etc.)</strong>
                  </span>
                  <span class="pre-modal__delivery-option-meta"> Mensajero por tu cuenta </span>
                </span>
              </label>

              <label class="pre-modal__delivery-option">
                <input
                  type="radio"
                  name="delivery_method"
                  value="home"
                  formControlName="delivery_method"
                />
                <span class="pre-modal__delivery-option-body">
                  <span class="pre-modal__delivery-option-title">
                    Recibir en <strong>Mi Dirección</strong>
                  </span>
                  <span class="pre-modal__delivery-option-meta"> Correos de Costa Rica </span>
                </span>
              </label>

              @if (psDeliveryEnabled) {
                <label
                  class="pre-modal__delivery-option"
                  [class.pre-modal__delivery-option--disabled]="psDeliveryOptionDisabled()"
                >
                  <input
                    type="radio"
                    name="delivery_method"
                    value="ps_delivery"
                    formControlName="delivery_method"
                    [attr.disabled]="psDeliveryOptionDisabled() ? '' : null"
                  />
                  <span class="pre-modal__delivery-option-body">
                    <span class="pre-modal__delivery-option-title">
                      {{ psDeliveryCopy.label }}
                    </span>
                    <span class="pre-modal__delivery-option-meta">
                      @if (psDeliveryOptionDisabled()) {
                        {{ psDeliveryCopy.disabledNote }}
                      } @else {
                        @if (psDeliveryPriceExact()) {
                          {{ formatCRC(psDeliveryPrice()) }}
                        } @else {
                          Desde {{ formatCRC(psDeliveryPrice()) }}
                        }
                        · {{ psDeliveryCopy.coverageNote }}
                      }
                    </span>
                  </span>
                </label>
              }
            </div>

            <!-- Fuera del radiogroup: contenido complementario, no una opción de radio (a11y). -->
            @if (psDeliveryEnabled) {
              <button
                type="button"
                class="pre-modal__coverage-link"
                (click)="destinationsOpen.set(true)"
              >
                {{ psDeliveryCopy.destinationsLink }}
              </button>
            }
          </fieldset>

          @if (requiresAddress()) {
            <fieldset class="pre-modal__fieldset">
              <legend class="pre-modal__legend">Dirección de envío *</legend>

              @if (locationsLoadError()) {
                <p class="pre-modal__field-error" role="alert">
                  No pudimos cargar el catálogo de ubicaciones. Escribe provincia, cantón y distrito
                  manualmente.
                </p>
              }

              <div class="pre-modal__grid">
                <label class="pre-modal__field">
                  <span class="pre-modal__field-label">Provincia *</span>
                  @if (locationsLoadError()) {
                    <input
                      type="text"
                      formControlName="province"
                      class="pre-modal__input"
                      [class.pre-modal__input--error]="hasError('province')"
                      (blur)="onManualLocationBlur()"
                    />
                  } @else {
                    <select
                      formControlName="province"
                      class="pre-modal__input"
                      [class.pre-modal__input--error]="hasError('province')"
                    >
                      <option value="" disabled>— Selecciona —</option>
                      @for (p of provinces(); track p.name) {
                        <option [value]="p.name">{{ p.name }}</option>
                      }
                    </select>
                  }
                  @if (hasError('province')) {
                    <span class="pre-modal__field-error" role="alert">{{
                      errorFor('province')
                    }}</span>
                  }
                </label>

                <label class="pre-modal__field">
                  <span class="pre-modal__field-label">Cantón *</span>
                  @if (locationsLoadError()) {
                    <input
                      type="text"
                      formControlName="canton"
                      class="pre-modal__input"
                      [class.pre-modal__input--error]="hasError('canton')"
                      (blur)="onManualLocationBlur()"
                    />
                  } @else {
                    <select
                      formControlName="canton"
                      class="pre-modal__input"
                      [class.pre-modal__input--error]="hasError('canton')"
                      [attr.disabled]="
                        !provinceValue() || availableCantons().length === 0 ? '' : null
                      "
                    >
                      <option value="" disabled>— Selecciona —</option>
                      @for (c of availableCantons(); track c.name) {
                        <option [value]="c.name">{{ c.name }}</option>
                      }
                    </select>
                  }
                  @if (hasError('canton')) {
                    <span class="pre-modal__field-error" role="alert">{{
                      errorFor('canton')
                    }}</span>
                  }
                </label>

                <label class="pre-modal__field">
                  <span class="pre-modal__field-label">Distrito *</span>
                  @if (locationsLoadError()) {
                    <input
                      type="text"
                      formControlName="district"
                      class="pre-modal__input"
                      [class.pre-modal__input--error]="hasError('district')"
                    />
                  } @else {
                    <select
                      formControlName="district"
                      class="pre-modal__input"
                      [class.pre-modal__input--error]="hasError('district')"
                      [attr.disabled]="
                        !cantonValue() || availableDistricts().length === 0 ? '' : null
                      "
                    >
                      <option value="" disabled>— Selecciona —</option>
                      @for (d of availableDistricts(); track d) {
                        <option [value]="d">{{ d }}</option>
                      }
                    </select>
                  }
                  @if (hasError('district')) {
                    <span class="pre-modal__field-error" role="alert">{{
                      errorFor('district')
                    }}</span>
                  }
                </label>

                <label class="pre-modal__field">
                  <span class="pre-modal__field-label">Barrio / residencial</span>
                  <input
                    type="text"
                    formControlName="hood"
                    class="pre-modal__input"
                    [class.pre-modal__input--error]="hasError('hood')"
                  />
                </label>
              </div>

              <label class="pre-modal__field pre-modal__field--wide">
                <span class="pre-modal__field-label">Señas *</span>
                <textarea
                  formControlName="directions"
                  rows="2"
                  class="pre-modal__input pre-modal__textarea"
                  [class.pre-modal__input--error]="hasError('directions')"
                ></textarea>
                @if (hasError('directions')) {
                  <span class="pre-modal__field-error" role="alert">{{
                    errorFor('directions')
                  }}</span>
                }
              </label>
            </fieldset>
          }

          <footer class="pre-modal__footer">
            <app-button variant="secondary" (click)="onClose()"> Cancelar </app-button>
            <!-- «Continuar al pago» abre la reserva flotante: spinner mientras
                 el backend responde (D5). -->
            <app-button
              variant="primary"
              type="submit"
              [disabled]="isDeadlinePassed() || eaLocked()"
              [loading]="sessionOpening()"
            >
              {{ copy.ctaContinue }}
            </app-button>
          </footer>
        </form>
      }
    </div>
  </section>

  <!-- Modal de comprobante reutilizado del checkout (split 30%/70% estilo
       apartado) con los overrides de copy de PRECOMPRA: la línea de condición
       («El 70% restante se paga al recibir el producto.») y el CTA
       («Listo, finalizar precompra»). El resto del copy es el del checkout.
       El countdown de la reserva también se ve AQUÍ (display-only: el evento
       de expiración lo maneja el countdown del paso de pago). -->
  <app-payment-data-modal
    [open]="paymentModalOpen()"
    [method]="paymentModalMethod()"
    [isLayaway]="true"
    [amountColones]="effectiveDeposit()"
    [remainingColones]="remainingAmount()"
    [submitting]="paymentModalSubmitting() || sessionOpening()"
    [errorMessage]="paymentModalError()"
    [copyOverrides]="paymentCopyOverrides()"
    [countdownExpiresAt]="sessionExpiresAt()"
    [countdownLabel]="copy.reservation.timer"
    (finalize)="onPaymentFinalize($event)"
    (dismiss)="onPaymentDismiss()"
  />

  <!-- Aviso de cobertura: el mensajero no llega al cantón elegido → cambio a Correos. -->
  <app-coverage-notice-dialog
    [open]="coverageDialogOpen()"
    [title]="psDeliveryCopy.dialog.title"
    [body]="psDeliveryCopy.dialog.body"
    [ctaLabel]="psDeliveryCopy.dialog.cta"
    (acknowledge)="onCoverageDialogAcknowledge()"
  />

  <!-- Modal informativo: provincias, tarifas y cantones del Mensajero Perrón Store. -->
  <app-ps-delivery-destinations-dialog
    [open]="destinationsOpen()"
    [title]="psDeliveryCopy.destinations.title"
    [intro]="psDeliveryCopy.destinations.intro"
    [ctaLabel]="psDeliveryCopy.destinations.cta"
    (close)="destinationsOpen.set(false)"
  />
}
